import { AmazonLogo, GoogleLogo, WalmartLogo, EbayLogo } from '@cf/ui-lib/icons';
export const imagesListMock = [
    {
        key: 'US',
        list: new Array(3).fill(1).map((_, index) => ({ src: GoogleLogo, key: `google-${index}-us` }))
    },
    {
        key: 'Paid search',
        list: new Array(3)
            .fill(1)
            .map((_, index) => ({ src: AmazonLogo, key: `amazon-${index}-search` }))
    },
    {
        key: 'International',
        list: new Array(10)
            .fill(1)
            .map((_, index) => ({ src: WalmartLogo, key: `facebook-${index}-international` }))
    },
    {
        key: 'Social',
        list: new Array(3)
            .fill(1)
            .map((_, index) => ({ src: EbayLogo, key: `tailwind-${index}-social` }))
    }
];
